
import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import "./Header.less"
import {
    fetch,
    setGender,
    setOrganizationName,
    setAgeGroup,
    setMinAge,
    setMaxAge,
    setConditions,
    setTags,
    setParam,
    setQueryString,
    setQueryType,
    setSort
} from "../../redux/query"
import store from "../../redux"
import TagSelector from "../TagSelector"
import AgeSelector from "../AgeSelector"
import SortWidget from "../SortWidget"
import RangePicker from "../ClaimReview/RangePicker"
import {
    getUserRole,
    parseQueryString,
    setHashParam
} from "../../lib"
import { isUserAdmin } from "../../lib/appPermissions"
import NavTabs from "../NavTabs"
import { oktaSignOut } from "../../auth/oktaSignOut"

export default class Header extends React.Component {
    static propTypes = {
        settings: PropTypes.object.isRequired,
        query: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        urlParams: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            filters: {
                dateFilter: "all",
                startDate: null,
                endDate: null
            }
        };
        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        const hasDateFilter = !!(
            this.props.query &&
            this.props.query.params &&
            (this.props.query.params.lastUpdatedFrom || this.props.query.params.lastUpdatedTo)
        );
        if (!hasDateFilter) {
            store.dispatch(fetch());
            return;
        }

        // If date params are already present (set by app init or from previous state),
        // run the patient fetch on entering/re-entering Patient List.
        store.dispatch(fetch());
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ dropdownOpen: false });
        }
    }

    applyDateFilter = (startDate, endDate) => {
        if (!startDate || !endDate) {
            store.dispatch(setParam({
                name: "lastUpdatedFrom",
                value: undefined
            }))
            store.dispatch(setParam({
                name: "lastUpdatedTo",
                value: undefined
            }))
            this.fetch()
            return
        }

        store.dispatch(setParam({
            name: "lastUpdatedFrom",
            value: moment(startDate).format("YYYY-MM-DD")
        }))
        // store.dispatch(setParam({
        //     name: "lastUpdatedTo",
        //     value: moment(endDate).format("YYYY-MM-DD")
        // }))
        this.fetch()
    };

    handleDateFilterChange = (value) => {
        let startDate = null;
        let endDate = moment().endOf("day");

        switch (value) {
            case "last_7_days":
                startDate = moment().subtract(6, "days").startOf("day");
                break;

            case "last_30_days":
                startDate = moment().subtract(29, "days").startOf("day");
                break;

            case "this_month":
                startDate = moment().startOf("month");
                endDate = moment().endOf("month");
                break;

            case "last_month":
                startDate = moment().subtract(1, "month").startOf("month");
                endDate = moment().subtract(1, "month").endOf("month");
                break;

            case "ytd":
                startDate = moment().startOf("year");
                break;

            case "all":
                this.setState(prev => ({
                    filters: {
                        ...prev.filters,
                        dateFilter: value,
                        startDate: null,
                        endDate: null
                    }
                }), () => this.applyDateFilter(null, null));
                return;

            case "custom":
                this.setState(prev => ({
                    filters: {
                        ...prev.filters,
                        dateFilter: value,
                        startDate: null,
                        endDate: null
                    }
                }), () => this.applyDateFilter(null, null));
                return;

            default:
                return;
        }

        this.setState({
            filters: {
                dateFilter: value,
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: endDate.format("YYYY-MM-DD")
            }
        }, () => this.applyDateFilter(startDate, endDate));
    };

    handleDateRangeChange = (start, end) => {
        this.setState(prev => ({
            filters: {
                ...prev.filters,
                startDate: moment(start).format("YYYY-MM-DD"),
                endDate: moment(end).format("YYYY-MM-DD")
            }
        }), () => this.applyDateFilter(start, end));
    };

    fetch(delay = 500) {
        if (this.props.settings.submitStrategy == "automatic") {
            if (this.fetchDelay) {
                clearTimeout(this.fetchDelay);
            }
            this.fetchDelay = setTimeout(() => {
                store.dispatch(fetch())
            }, delay)
        }
    }

    renderAdvancedTabContents() {
        return (
            <div className="form-group">
                <p className="text-warning" style={{ padding: "0 5px 5px", margin: 0 }}>
                    <i className="fa fa-info-circle" /> In advanced mode, provide a
                    query string to browse and select from a list of matching
                    patients. <a target="_blank" href="http://hl7.org/fhir/patient.html#search">More Info...</a>
                </p>
                <form onSubmit={e => {
                    e.preventDefault()
                    store.dispatch(fetch())
                }}>
                    <div className="input-group input-group-sm">
                        <span className="input-group-addon">/Patient?</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Patient Search Query String"
                            name="query"
                            onChange={e => store.dispatch(setQueryString(e.target.value))}
                            value={this.props.query.queryString}
                        />
                        <span className="input-group-btn">
                            <button className="btn btn-warning" type="submit">Go</button>
                        </span>
                    </div>
                </form>
            </div>
        )
    }

    renderDemographicsTabContents() {
        const { filters } = this.state;
        return (
            <form onSubmit={e => {
                e.preventDefault()
                store.dispatch(fetch())
            }}>
                <div className="row">
                    <div className={"**custom**" === this.props.query.ageGroup ? "col-sm-6" : "col-sm-4"}>
                        <div className="form-group">
                            <div className="input-group">
                                <span className="input-group-addon"><small>MRN:</small></span>
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder="Search by MRN..."
                                    value={this.props.query.params.identifier || ""}
                                    onChange={e => {
                                        store.dispatch(setParam({
                                            name: "identifier",
                                            value: e.target.value
                                        }))
                                        this.fetch()
                                    }}
                                    onKeyDown={e => {
                                        console.log(e.key)
                                        if (e.key == "Enter") {
                                            store.dispatch(fetch())
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"**custom**" === this.props.query.ageGroup ? "col-sm-6" : "col-sm-8"}>
                        <div className="form-group">
                            <div className="input-group">
                                <span className="input-group-addon"><small>Name:</small></span>
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder="Search by name..."
                                    value={this.props.query.params.name || ""}
                                    onChange={e => {
                                        store.dispatch(setParam({
                                            name: "name",
                                            value: e.target.value
                                        }))
                                        this.fetch()
                                    }}
                                    onKeyDown={e => {
                                        console.log(e.key)
                                        if (e.key == "Enter") {
                                            store.dispatch(fetch())
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            {/*<label>Gender:</label>*/}
                            <select
                                className="form-control input-sm"
                                onChange={e => {
                                    store.dispatch(setGender(e.target.value))
                                    this.fetch()
                                }}
                                value={this.props.query.gender || ""}
                            >
                                <option value="male">Males</option>
                                <option value="female">Females</option>
                                <option value="">Any Gender</option>
                            </select>
                        </div>
                    </div>
                    <div className={"**custom**" === this.props.query.ageGroup ? "col-sm-12" : "col-sm-3"}>
                        <div className="form-group">
                            {/*<label>Age:</label>*/}
                            <AgeSelector
                                min={this.props.query.minAge || { value: 0, units: "years" }}
                                max={this.props.query.maxAge || { value: 100, units: "years" }}
                                onMinChange={age => {
                                    store.dispatch(setMinAge(age))
                                    //if ("**custom**" != this.props.query.ageGroup) {
                                    this.fetch()
                                    //}
                                }}
                                onMaxChange={age => {
                                    store.dispatch(setMaxAge(age))
                                    //if ("**custom**" != this.props.query.ageGroup) {
                                    this.fetch()
                                    //}
                                }}
                                onGroupChange={group => {
                                    store.dispatch(setAgeGroup(group))
                                    //if ("**custom**" != this.props.query.ageGroup) {
                                    this.fetch()
                                    //}
                                }}
                                //update={ () => this.fetch() }
                                group={this.props.query.ageGroup}
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            {/*<label>Gender:</label>*/}
                            <select
                                className="form-control input-sm"
                                onChange={e => {
                                    store.dispatch(setOrganizationName(e.target.value))
                                    this.fetch()
                                }}
                                value={this.props.query.organizationName || ""}
                            >
                                <option value="">Any Health Plan</option>
                                <option value="CENTRAL CA ALLIANCE FOR HEALTH">CCAH - CENTRAL CA ALLIANCE FOR HEALTH</option>
                                <option value="CENTRAL ALLIANCE FOR HEALTH">CCAH - CENTRAL ALLIANCE FOR HEALTH</option>
                                <option value="Health Plan of San Joaquin">HPSJ - Health Plan of San Joaquin</option>
                                <option value="GOLDEN VALLEY HEALTH CENTERS">GVHC - GOLDEN VALLEY HEALTH CENTERS</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="d-flex">
                            <div className="d-flex align-items-center" style={{ width: filters.dateFilter === 'custom' ? "30%" : "100%" }}>
                                <select
                                    className="form-control input-sm"
                                    value={filters.dateFilter}
                                    onChange={(e) => this.handleDateFilterChange(e.target.value)}
                                >
                                    <option value="last_7_days">Last 7 Days</option>
                                    <option value="last_30_days">Last 30 Days</option>
                                    <option value="this_month">This Month</option>
                                    <option value="last_month">Last Month</option>
                                    <option value="ytd">Year to Date</option>
                                    <option value="all">All</option>
                                    <option value="custom">Custom Range</option>
                                </select>
                            </div>
                            {filters.dateFilter === 'custom' && (
                                <div style={{ width: "70%" }}>
                                    <div className="d-flex align-items-center justify-end">
                                        <RangePicker
                                            onRangeChange={this.handleDateRangeChange}
                                            className={"input-sm w-100"}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    renderConditionsTabContents() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <TagSelector
                            tags={
                                Object.keys(this.props.settings.server.conditions).map(key => {
                                    let condition = this.props.settings.server.conditions[key];
                                    return {
                                        key,
                                        label: condition.description,
                                        data: condition
                                    }
                                })
                            }
                            onChange={
                                selection => {
                                    let conditions = {}
                                    selection.forEach(tag => {
                                        conditions[tag.key] = tag.data
                                    })
                                    store.dispatch(setConditions(conditions))
                                    this.fetch()
                                }
                            }
                            label="condition code"
                            selected={Object.keys(this.props.query.conditions)}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderTagsTabContents() {
        let selected = this.props.query.tags || this.props.settings.server.tags.filter(
            tag => !!tag.selected
        ).map(tag => !!tag.key);
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <TagSelector
                            tags={this.props.settings.server.tags}
                            selected={selected}
                            onChange={
                                sel => {
                                    let tags = Object.keys(sel).map(k => sel[k].key)
                                    store.dispatch(setTags(tags))
                                    this.fetch()
                                }
                            }
                            label="tag"
                        />
                    </div>
                </div>
            </div>
        )
    }

    handleLogout = () => {
        oktaSignOut();
    };


    render() {
        let _query = parseQueryString(this.props.location.search);
        let _advanced = this.props.query.queryType == "advanced";
        let conditionsCount = Object.keys(this.props.query.conditions).length;
        let demographicsCount = 0;
        let tagsCount = Object.keys(this.props.query.tags).length;

        // Compute which the active tab should be
        let tabs = ["search", "conditions"];
        if (!this.props.settings.hideTagSelector) {
            tabs.push("tags");
        }
        let _tab = _query._tab || "";
        if (tabs.indexOf(_tab) == -1) {
            _tab = "demographics";
        }

        // Manually increment the value for the demographics badge depending on
        // the state of the app

        if (this.props.query.gender) {
            demographicsCount += 1;
        }

        if (this.props.query.params.name) {
            demographicsCount += 1;
        }

        if (this.props.query.maxAge !== null || this.props.query.minAge !== null) {
            demographicsCount += 1;
        }

        return (
            <div className="app-header">
                <div style={{ flexDirection: "row" }}>
                    <div className="pull-right user-dropdown" ref={this.dropdownRef} style={{ top: '0.25rem', right: "0.5rem", position: 'relative' }}>
                        <i
                            className="fa fa-user-circle"
                            style={{ fontSize: '24px', color: '#d9534f', cursor: 'pointer' }}
                            onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                        />
                        {this.state.dropdownOpen && (
                            <div style={{
                                position: 'absolute',
                                right: 0,
                                top: '100%',
                                marginTop: '5px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                minWidth: '180px',
                                zIndex: 1000000000
                            }}>
                                {isUserAdmin(getUserRole()) && (
                                    <div
                                        onClick={() => {
                                            this.setState({ dropdownOpen: false });
                                            window.location.href = "/user-management";
                                        }}
                                        style={{
                                            padding: '8px 15px',
                                            cursor: 'pointer',
                                            color: '#333'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                    >
                                        <i className="fa fa-user" /> User Management
                                    </div>
                                )}
                                <div
                                    onClick={() => {
                                        this.setState({ dropdownOpen: false });
                                        window.location.href = "/mirth-audit-log";

                                    }}
                                    style={{
                                        padding: '8px 15px',
                                        cursor: 'pointer',
                                        color: '#333'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    <i className="fa fa-history" /> Audit Log
                                </div>
                                <div
                                    onClick={() => {
                                        this.setState({ dropdownOpen: false });
                                        this.handleLogout();
                                    }}
                                    style={{
                                        padding: '8px 15px',
                                        cursor: 'pointer',
                                        color: '#333'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    <i className="fa fa-sign-out" /> Logout
                                </div>
                            </div>
                        )}
                    </div>
                    <label className="pull-right advanced-label text-warning" style={{ marginRight: "1rem" }}>
                        <input
                            type="checkbox"
                            checked={_advanced}
                            onChange={e => {
                                store.dispatch(setQueryType(e.target.checked ? "advanced" : "basic"))
                            }}
                        /> Advanced <span className="hidden-xs">Mode</span>
                    </label>
                    <NavTabs
                        settings={this.props.settings}
                        query={this.props.query}
                        currentTab={_tab}
                        demographicsCount={demographicsCount}
                        conditionsCount={conditionsCount}
                        tagsCount={tagsCount}
                        isAdvanced={_advanced}
                    />
                </div>
                <div className="tab-content">
                    <div className={"tab-pane " + (_advanced ? "active" : "")}>
                        {this.renderAdvancedTabContents()}
                    </div>
                    <div className={"tab-pane " + (!_advanced && _tab == "demographics" ? "active" : "")}>
                        {this.renderDemographicsTabContents()}
                    </div>
                    <div className={"tab-pane " + (!_advanced && _tab == "conditions" ? "active" : "")}>
                        {this.renderConditionsTabContents()}
                    </div>
                    {
                        (this.props.settings.hideTagSelector ||
                            this.props.query.params._id) ?
                            null :
                            <div className={"tab-pane " + (!_advanced && _tab == "tags" ? "active" : "")}>
                                {this.renderTagsTabContents()}
                            </div>
                    }
                    {
                        !_advanced && this.props.settings.submitStrategy == "manual" ?
                            <div className="text-right" style={{ height: 0 }}>
                                <button
                                    type="button"
                                    onClick={() => store.dispatch(fetch())}
                                    className="btn btn-primary btn-submit"
                                >
                                    <i className="fa fa-search" /> Search
                                </button>
                            </div> :
                            null
                    }
                </div>
                {
                    _advanced ?
                        null :
                        <SortWidget
                            sort={this.props.query.sort}
                            onChange={sort => {
                                store.dispatch(setSort(sort))
                                store.dispatch(fetch())
                            }}
                        />
                }
            </div>
        )
    }
}
